export default __webpack_public_path__ + "static/media/riftbound_rare.f0ab68cf.svg";